import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "43",
  height: "43",
  viewBox: "0 0 43 43",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.7463 19.2917H6.04167C8.48092 19.2917 10.4583 21.2691 10.4583 23.7083V25.9167C10.4583 28.3559 12.4357 30.3333 14.875 30.3333C17.3143 30.3333 19.2917 32.3107 19.2917 34.75V41.2537M12.6667 3.69094V7.14583C12.6667 10.1949 15.1384 12.6667 18.1875 12.6667H19.2917C21.7309 12.6667 23.7083 14.6441 23.7083 17.0833C23.7083 19.5226 25.6857 21.5 28.125 21.5C30.5643 21.5 32.5417 19.5226 32.5417 17.0833C32.5417 14.6441 34.5191 12.6667 36.9583 12.6667L39.3091 12.6667M28.125 40.2441V34.75C28.125 32.3107 30.1024 30.3333 32.5417 30.3333H39.3091M41.375 21.5C41.375 32.4767 32.4767 41.375 21.5 41.375C10.5233 41.375 1.625 32.4767 1.625 21.5C1.625 10.5233 10.5233 1.625 21.5 1.625C32.4767 1.625 41.375 10.5233 41.375 21.5Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }